import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { urlSerialize } from 'lib'
import Logger from 'services/Logger'
import { CampaignIDs } from 'types/index'
import { getImpressionsClient } from 'services/FionaAPI/clients'
import { getClientTagsFromURL } from '../MultiProductWidget/ClientTags'
import { ImpressionWithId } from 'generated/api'

export interface BBMWidgetParams {
	loan_type?: 'REFI' | 'Purchase'
	external?: string
	credit_score?: string
	zip?: string
	siteid?: string
	listingbtnbgcolor?: string
	searchbtnbgcolor?: string
	result_count?: number
	hideheader?: number
}

const baseBBMParams: BBMWidgetParams = {
	// pubid: '6958e75ba6b00b8b',
	siteid: '1598629b0b225260',
	listingbtnbgcolor: '14e075',
	searchbtnbgcolor: '592b86',
	result_count: 6,
	hideheader: 1
}

interface Props {
	defaultFilters?: BBMWidgetParams
	campaign: CampaignIDs | string
}

const EMBED_URL = 'https://widgets.icanbuy.com/c/standard/us/en/mortgage/tables/Mortgage.aspx'

const MortgageWidget = ({ defaultFilters = {}, campaign }: Props): JSX.Element => {
	const [iFrameSrc, setIFrameSource] = useState<string | undefined>()
	const [impressionId, setImpressionId] = useState<string | undefined>(undefined)
	const [isImpressionIdLoading, setIsImpressionIdLoading] = useState(false)

	useEffect(() => {
		setIsImpressionIdLoading(true)
		async function getImpressionId(): Promise<void> {
			const impressionClient = getImpressionsClient()
			const clientTags = getClientTagsFromURL()
			const toSend = {
				impressionRequest: { campaign, utmPageMetadata: { ...clientTags } }
			}
			impressionClient
				.createImpression(toSend)
				.then((response: ImpressionWithId) => {
					setImpressionId(response.id)
					setIsImpressionIdLoading(false)
				})
				.catch(err => {
					setIsImpressionIdLoading(false)
					Logger.error(err)
				})
		}

		getImpressionId()
	}, [campaign])

	useEffect(() => {
		if (!isImpressionIdLoading) {
			const params = urlSerialize({
				...baseBBMParams,
				...defaultFilters,
				external: impressionId
			})
			setIFrameSource(`${EMBED_URL}?${params}`)
		}
	}, [isImpressionIdLoading, defaultFilters, impressionId])

	return (
		<IframeWrapper>
			{iFrameSrc && (
				<Iframe>
					<iframe
						id="iFrameResizer0"
						src={iFrameSrc}
						style={{ border: 'none', width: '100%', maxWidth: '100%' }}
						className="even-iframe"
						data-testid="iframe"
					/>
				</Iframe>
			)}
		</IframeWrapper>
	)
}

export default MortgageWidget

const Iframe = styled.div`
	iframe {
		min-height: 900px;

		@media only screen and (max-width: 490px) {
			min-height: 1600px;
		}
	}
`

const IframeWrapper = styled.div``
